import axios from 'axios';
import { baseUrl } from '@/config';

/**
 * objtype API
 * @author najongdang
 */
export default {
  /**
   * managetypeId 별 objtype list를 반환한다
   * @author najongdang
   * @param  {string} managetypeId [managetypeId]
   * @return {array}             objtype 배열
   */
  getObjtypeList(managetypeId) {
    return axios.get(`${baseUrl}/common/obj-type/get-objtype-list.do`, { params: { managetypeId } });
  },
  /**
   * 현재 제공 중인 managetypeId별 objtype 목록을 반환한다.
   * @author Ju
   * @param  {String} managetypeId managetypeId
   * @return {Object}
   */
  getProviedObjtypeList(managetypeId) {
    return axios.get(`${baseUrl}/common/obj-type/get-provied-objtype-list.do`, { params: { managetypeId } });
  },
  /**
   * 현재 애플망고에서 제공하는 센서의 objtype_id를 리스트로 반환한다.
   * @author Song
   * @param  {string}
   * @return {array}
   */
  getAvailableSensorList() {
    return axios.get(`${baseUrl}/common/obj-type/get-available-sensor-list.do`);
  },
};



// WEBPACK FOOTER //
// ./src/api/model/objtype.js